<div class="appo-appointment-request-requirements">
  <form #appoAppointmentRequestRequirementsForm="ngForm"
        id="{{formId}}"
        name="{{formId}}">
    <div class="row" [class.readmode]="readMode">
      <div class="col-12 col-lg-4 mt-2"
           [class.mb-3]="multipleInsuranceAvailable">
        <si-health-insurance-selector text="SI_HAVE_INSURANCE"
                                      tooltipText="{{isPatient ? 'SI_REGISTER_INSURANCE_INFO' : ''}}"
                                      [(privateInsurance)]="model.privateInsurance"
                                      [(collective)]="model.collective"
                                      (collectiveChange)="onChangeCollective()"
                                      [showButton]="isPatient && !readMode"
                                      [disabled]="readMode"
        ></si-health-insurance-selector>
      </div>
      <ng-container *ngIf="defaultAppointmentSlotSearch === appointmentSlotSearchOptions.ALL">
        <div class="w-100 d-none d-lg-block"></div>
        <div class="col-12"
             [class.mb-3]="model.searchBy">
          <si-label text="{{'SI_HOW_YOU_WANT_SEARCH_APPOINTMENT' | translate}}" styleClass="mb-2"></si-label>
          <div class="row g-3">
            <div class="col-4 col-lg-auto">
              <button siPreventDoubleClick
                      type="button"
                      class="si-button_card flex-column flex-lg-row align-items-center justify-content-center w-100"
                      [class.si-button_card-selected]="model.searchBy === appointmentSlotSearchOptions.CENTER"
                      (click)="onSelectAppointmentSlotSearchBy(appointmentSlotSearchOptions.CENTER, true)">
                <si-svg-icon iconPath="assets/images/center.svg" class="mb-1 mb-lg-0 mr-lg-2"></si-svg-icon>
                <span>{{'SI_BY_CENTER' | translate}}</span>
              </button>
            </div>
            <div class="col-4 col-lg-auto">
              <button siPreventDoubleClick
                      type="button"
                      class="si-button_card flex-column flex-lg-row align-items-center justify-content-center w-100"
                      [class.si-button_card-selected]="model.searchBy === appointmentSlotSearchOptions.SERVICE"
                      (click)="onSelectAppointmentSlotSearchBy(appointmentSlotSearchOptions.SERVICE, true)">
                <si-svg-icon iconPath="assets/images/service.svg" class="mb-1 mb-lg-0 mr-lg-2"></si-svg-icon>
                <span>{{'SI_BY_SERVICE' | translate}}</span>
              </button>
            </div>
            <div class="col-4 col-lg-auto">
              <button siPreventDoubleClick
                      type="button"
                      class="si-button_card flex-column flex-lg-row align-items-center justify-content-center w-100"
                      [class.si-button_card-selected]="model.searchBy === appointmentSlotSearchOptions.PROFESSIONAL"
                      (click)="onSelectAppointmentSlotSearchBy(appointmentSlotSearchOptions.PROFESSIONAL, true)">
                <si-svg-icon iconPath="assets/images/cuadro_medico.svg" class="mb-1 mb-lg-0 mr-lg-2"></si-svg-icon>
                <span>{{'SI_BY_PROFESSIONAL' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="model.searchBy; else hiddenInputWithValidator">
        <div class="w-100 d-none d-lg-block"></div>
        <div class="col-12">
          <div class="row g-3 pasi-gap-v-6 d-flex flex-wrap">
            <div class="col-12 col-lg-4"
                 [ngClass]="{
                   'order-1': model.searchBy === appointmentSlotSearchOptions.CENTER,
                   'order-3': model.searchBy === appointmentSlotSearchOptions.SERVICE,
                   'order-4': model.searchBy === appointmentSlotSearchOptions.PROFESSIONAL
                 }">
              <si-selector id="appoCenter"
                           name="appoCenter"
                           text="SI_CENTER"
                           placeholder="SI_SELECT_PLACEHOLDER"
                           [(model)]="model.center"
                           (modelChange)="onChangeCenter()"
                           [values]="centerValues"
                           [selectSingle]="true"
                           [disabled]="!model.collective || readMode"
                           rule="generic.fieldNotNull"
              ></si-selector>
            </div>
            <div class="w-100 d-none d-lg-block order-2"></div>
            <div class="col-12 col-lg-4"
                 [ngClass]="{
                   'order-3': model.searchBy === appointmentSlotSearchOptions.CENTER || model.searchBy === appointmentSlotSearchOptions.PROFESSIONAL,
                   'order-1': model.searchBy === appointmentSlotSearchOptions.SERVICE
                 }">
              <si-selector id="appoService"
                           name="appoService"
                           text="SI_SERVICE"
                           placeholder="SI_SELECT_PLACEHOLDER"
                           [(model)]="model.service"
                           (modelChange)="onChangeService()"
                           [values]="serviceValues"
                           [selectSingle]="true"
                           [disabled]="!model.collective || readMode"
                           rule="generic.fieldNotNull"
              ></si-selector>
            </div>
            <div class="col-12 col-lg-4"
                 [ngClass]="{
                   'order-4': model.searchBy === appointmentSlotSearchOptions.CENTER || model.searchBy === appointmentSlotSearchOptions.SERVICE,
                   'order-1': model.searchBy === appointmentSlotSearchOptions.PROFESSIONAL
                 }">
              <si-selector id="appoProfesional"
                           name="appoProfesional"
                           text="SI_PROFESSIONAL"
                           placeholder="SI_SELECT_PLACEHOLDER_APPO_REQUIREMENTS_PROFESSIONAL"
                           [(model)]="model.professional"
                           (modelChange)="onChangeProfessional()"
                           [values]="professionalValues"
                           [disabled]="!model.collective || readMode || ((!model.center || !model.service) && model.searchBy !== appointmentSlotSearchOptions.PROFESSIONAL)"
              ></si-selector>
            </div>
          </div>
        </div>
        <ng-container *ngFor="let alert of guarantorAlerts">
          <div class="w-100"></div>
          <div class="col-12 col-lg-8 mt-3">
            <si-generic-alert [showAlert]="true"
                              [styleClass]="appointmentNoticeCategoriesClass[alert.category?.code]"
                              [text]="alert.description"
            ></si-generic-alert>
          </div>
        </ng-container>
        <ng-container *ngIf="!isRequestTask && isLogged && !(null | siExternalReference)">
          <ng-container *siSecure="['procedure:appointment_create']">
              <div class="col-12 my-3" [ngClass]="{'d-flex justify-content-center': !isDesktopWidth}">
              <button class="si-button_link-thick h-100"
                      (click)="onClickButtonRegisterRequest()">
                <span>{{'SI_CANT_FIND_WHAT_YOU_NEED_QUESTION' | translate}}</span>
              </button>
            </div>
            <div class="col-12 pasi-line-lightgrey m-0"></div>
          </ng-container>
        </ng-container>
        <div class="w-100 mt-2 mb-1"></div>
        <div class="col-12 col-lg-4 mb-1">
          <si-selector id="appoReason"
                       name="appoReason"
                       text="SI_APPOINTMENT_REASON"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="model.appointmentReason[0]"
                       (modelChange)="onChangeAppointmentReason()"
                       [values]="appointmentReasonValues"
                       [showClear]="false"
                       [selectSingle]="true"
                       [disabled]="!model.center || !model.service || !model.collective || readMode"
                       rule="generic.fieldNotNull"
          ></si-selector>
        </div>
        <ng-container *ngFor="let alert of appointmentReasonsAlerts">
          <div class="w-100"></div>
          <div class="col-12 col-lg-8 mt-3">
            <si-generic-alert [showAlert]="true"
                              [styleClass]="appointmentNoticeCategoriesClass[alert.category?.code]"
                              [text]="alert.description"
            ></si-generic-alert>
          </div>
        </ng-container>
        <div class="col-12 pasi-line-lightgrey"></div>
        <div class="col-12 mt-1 mb-2 appo-appointment-request-requirements_text"
             [class.disabled]="!model.center?.name || !model.service?.name || readMode">
          <div>{{'SI_SELECT_DAY_AND_RANGE' | translate}}</div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 mb-1 mb-sm-0">
          <si-datepicker id="appoFrom"
                         name="appoFrom"
                         text="SI_FROM"
                         placeholder="CORE_DATEPICKER_L"
                         [(model)]="model.fromDate"
                         startOf="day"
                         [onlyFuture]="true"
                         [disabled]="!model.center || !model.service || !model.collective || readMode"
                         rule="generic.fieldNotNull"
          ></si-datepicker>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 mt-2 mt-sm-0">
          <si-selector id="appoTimePreference"
                       name="appoTimePreference"
                       text="SI_SCHEDULE"
                       placeholder="SI_SELECT_PLACEHOLDER"
                       [(model)]="model.timePreference"
                       path="/api/v1/timePreference?centerId={{model.center?.id || model.center}}"
                       [showClear]="false"
                       [showDropdownSearch]="false"
                       [selectDefault]="true"
                       (selectDefaultChange)="selectDefaultLoaded($event, 'timePreference')"
                       [disabled]="!model.center || !model.service || !model.collective || readMode"
                       rule="generic.fieldNotNull"
          ></si-selector>
        </div>
        <ng-container *ngIf="isRequestTask">
          <div class="w-100"></div>
          <div class="col-12 col-lg-8 mt-2">
            <si-multiline id="appoComments"
                          name="appoComments"
                          text="SI_COMMENT"
                          placeholder="SI_WRITE_HERE"
                          [(model)]="model.reason"
                          [rows]="4"
                          [disabled]="!model.center || !model.service || !model.collective || readMode"
                          rule="generic.length500"
            ></si-multiline>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #hiddenInputWithValidator>
        <div [hidden]="true">
          <si-input id="hiddenValidator"
                    name="hiddenValidator"
                    type="hidden"
                    rule="generic.fieldNotNull"
          ></si-input>
        </div>
      </ng-template>
    </div>
  </form>
</div>
